<template>
  <div class="container-fluid container-fluid--cp-150">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand class="navbar-brand logo-light" to="/">
      <img
        src="../assets/img/logo/light-logo.png"
        style="max-height: 100px; max-width: 100px"
        alt="logo"
      />
    </b-navbar-brand>
    <b-navbar-brand class="navbar-brand logo-dark" to="/">
      <img
        src="../assets/img/logo/logo-dark.png"
        style="max-height: 100px; max-width: 100px"
        alt="logo"
      />
    </b-navbar-brand>
    <b-collapse
      class="default-nav justify-content-center"
      is-nav
      id="nav_collapse"
    >
      <b-navbar-nav class="navbar-nav main-menu text-white">
        <b-nav-item class="scroll">
          <router-link :to="{ name: 'home' }">
            <span>HOME</span>
          </router-link>
        </b-nav-item>
        <b-nav-item class="scroll">
          <router-link :to="{ name: 'about-us' }">
            <span class="text-nowrap">ABOUT US</span>
          </router-link>
        </b-nav-item>
        <b-nav-item class="scroll">
          <router-link :to="{ name: 'our-services' }">
            <span>SERVICES</span>
          </router-link>
        </b-nav-item>
        <b-nav-item class="scroll">
          <router-link :to="{ name: 'partners' }">
            <span>PARTNERS</span>
          </router-link>
        </b-nav-item>
        <b-nav-item class="scroll">
          <router-link :to="{ name: 'clients' }">
            <span>CLIENTS</span>
          </router-link>
        </b-nav-item>
        <!--        <b-nav-item class="scroll">-->
        <!--          <router-link :to="{ name: 'products' }">-->
        <!--            <span class="text-nowrap">FLAGSHIP PRODUCTS</span>-->
        <!--          </router-link>-->
        <!--        </b-nav-item>-->
        <b-nav-item class="scroll">
          <router-link :to="{ name: 'contact-us' }">
            <span class="text-nowrap">CONTACT US</span>
          </router-link>
        </b-nav-item>
        <b-nav-item class="scroll">
          <router-link :to="{ name: 'faqs' }">
            <span class="text-nowrap">FAQS</span>
          </router-link>
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
    <b-btn-group class="header-button button--white d-none d-xl-block">
      <b-link :to="{ name: 'hire-us' }" class="btn btn--white text-nowrap"
        >Hire Us Now</b-link
      >
    </b-btn-group>
  </div>
</template>

<script>
export default {
  name: "NavBarHeader",
  data() {
    return {
      load: false,
      limitPosition: 200,
      scrolled: false,
      lastPosition: 500,
    };
  },
  mounted() {
    (function () {
      scrollTo();
    })();

    function scrollTo() {
      const links = document.querySelectorAll(".scroll > a");
      links.forEach((each) => (each.onclick = scrollAnchors));
    }

    function scrollAnchors(e, respond = null) {
      const distanceToTop = (el) => Math.floor(el.getBoundingClientRect().top);
      e.preventDefault();
      var targetID = respond
        ? respond.getAttribute("href")
        : this.getAttribute("href");
      const targetAnchor = document.querySelector(targetID);
      if (!targetAnchor) return;
      const originalTop = distanceToTop(targetAnchor);
      window.scrollBy({ top: originalTop, left: 0, behavior: "smooth" });
      const checkIfDone = setInterval(function () {
        const atBottom =
          window.innerHeight + window.pageYOffset >=
          document.body.offsetHeight - 190;
        if (distanceToTop(targetAnchor) === 0 || atBottom) {
          targetAnchor.tabIndex = "-1";
          targetAnchor.focus();
          //window.history.pushState('', '', targetID);
          clearInterval(checkIfDone);
        }
      }, 800);
    }
  },
  methods: {
    // sticky menu script
    handleScroll() {
      if (
        this.lastPosition < window.scrollY &&
        this.limitPosition < window.scrollY
      ) {
        this.scrolled = true;
        // move up!
      }

      if (this.lastPosition > window.scrollY) {
        this.scrolled = true;
        // move down
      }

      this.lastPosition = window.scrollY;
      this.scrolled = window.scrollY > 50;
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
